/**
 * API配置管理
 * 统一管理所有API相关的配置
 */

// 获取环境变量
const getEnvVar = (key, defaultValue = '') => {
    return process.env[key] || defaultValue
}

// API配置
export const API_CONFIG = {
    // 基础URL配置
    BASE_URL: getEnvVar('VUE_APP_BASE_API', 'http://localhost:8080/api'),

    // 超时配置
    TIMEOUT: parseInt(getEnvVar('VUE_APP_TIMEOUT', '15000')),

    // 调试模式
    DEBUG: getEnvVar('VUE_APP_DEBUG', 'false') === 'true',

    // 日志级别
    LOG_LEVEL: getEnvVar('VUE_APP_LOG_LEVEL', 'error'),

    // 是否启用模拟数据
    MOCK_ENABLED: getEnvVar('VUE_APP_MOCK', 'false') === 'true'
}

// API端点配置
export const API_ENDPOINTS = {
    // 认证相关
    AUTH: {
        LOGIN: '/admin/login',
        LOGOUT: '/admin/logout',
        REFRESH: '/admin/refresh'
    },

    // 用户管理
    USER: {
        LIST: '/admin/users',
        CREATE: '/admin/users',
        UPDATE: '/admin/users',
        DELETE: '/admin/users',
        DETAIL: '/admin/users'
    },

    // 积分管理
    POINTS: {
        LIST: '/admin/points',
        GRANT: '/admin/points/grant',
        HISTORY: '/admin/points/history'
    },

    // 语音合成管理
    SYNTHESIS: {
        LIST: '/admin/synthesis',
        DELETE: '/admin/synthesis',
        CLEANUP: '/admin/synthesis/cleanup'
    },

    // 系统管理
    SYSTEM: {
        INFO: '/admin/system/info',
        SETTINGS: '/admin/system/settings',
        STATS: '/admin/system/stats'
    },

    // 仪表板
    DASHBOARD: {
        STATS: '/admin/dashboard/stats',
        CHARTS: '/admin/dashboard/charts'
    },

    // 兑换码管理
    EXCHANGE_CODE: {
        LIST: '/admin/exchange-codes',
        CREATE: '/admin/exchange-codes',
        DELETE: '/admin/exchange-codes'
    },

    // 语音模型管理
    VOICE_MODEL: {
        LIST: '/admin/voice-models',
        CREATE: '/admin/voice-models',
        UPDATE: '/admin/voice-models',
        DELETE: '/admin/voice-models'
    }
}

// HTTP状态码
export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500
}

// 响应代码
export const RESPONSE_CODE = {
    SUCCESS: 200,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    SERVER_ERROR: 500
}

export default {
    API_CONFIG,
    API_ENDPOINTS,
    HTTP_STATUS,
    RESPONSE_CODE
}
